<template>
  <!-- 协会章程 -->
  <div class="top-tab">
    <div :class="{'is-select':$route.path == item.path}" class="item" v-for="item,i in data" :key="i" @click.stop="$router.push({path:item.path})">{{item.label}}</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
        data:[
            {
                label:"关于协会"
            },
            {
                label:"协会章程",
                path:'/association/constitution'
            },
            {
                label:"行业诚信公约",
                path:'/association/convention'
            },
            {
                label:"信息公开制度",
                path:'/association/publicity-system'
            },
            {
                label:"服务承诺书"
            },
            {
                label:"领导班子"
            },
            {
                label:"协会机构"
            },
            {
                label:"联系方式"
            }
        ]
    };
  },
  methods: {},
};
</script>
 
<style lang="less" scoped>
.top-tab {
  width: 1200px;
  height: 70px;
  background-color: rgba(247, 247, 247, 1);
  display: flex;
  .item {
    cursor: pointer;
    width: 143px;
    height: 70px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: rgba(0, 0, 0, 1);
    font-size: 18px;
    &.is-select{
        color: #fff;
        background-size: cover;
        background-color: rgba(22, 81, 254, 1);
        background-image: url('../../../assets/icon/tab-select.png');
    }
  }
}
</style>